import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the datatable for withdrawal requests.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' }, // Date column
                { id: 'User', header: _('Usuario'), width: 100, sort: 'int' }, // User column
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo', // Combo editor for state
                    options: [
                        // State options
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 150,
                    sort: 'int',
                },
                { id: 'Token', header: _('Código'), width: 100, sort: 'int' }, // Token column
            ],
            editable: true, // Enable editing
            footer: true, // Show footer
            math: true, // Enable math functions
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API URL for data loading
            url: devConfig.geturlApi() + '/UserManagement/GetUserSecurityL?LeagueId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // Data URL

        // Event listener for filtering data
        this.on(this.app, 'generateTokenAgentList:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Start date
                                    var dateFrom =
                                        'FromDateLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add FromDateLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // End date
                                        var dateTo =
                                            'ToDateLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add ToDateLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for before edit start
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get item being edited
            console.log(item);
            if (id.column == 'State') {
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    options.remove('A'); // Remove 'Activado' option
                } else if (item.State == 'I') {
                    options.remove('I'); // Remove 'Inactivado' option
                } else {
                    return false; // Prevent editing if state is not valid
                }
                console.log(id);
            }
        });

        // Event listener for after edit stop
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if value changed
                if (state.value == 'A') {
                    webix // AJAX call to allow withdrawal requests
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
                if (state.value == 'P') {
                    webix // AJAX call to pay withdrawal requests
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
                if (state.value == 'E') {
                    webix // AJAX call to cancel client requests
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
